import { render } from "./TimeExpired.vue?vue&type=template&id=57b8fea2&scoped=true"
import script from "./TimeExpired.vue?vue&type=script&lang=js"
export * from "./TimeExpired.vue?vue&type=script&lang=js"

import "./TimeExpired.vue?vue&type=style&index=0&id=57b8fea2&lang=scss&scoped=true"

import exportComponent from "/home/forge/vienaiespeja.on-forge.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57b8fea2"]])

export default __exports__